import { BlockBoundary } from '@shared/lib/components/BlockBoundary'
import { Modal } from '@shared/ui/Overlays/Modal'
import s from './Modals.module.sass'
import Img from '@images/restorator/statics.webp'
import Image from 'next/image'
import { Text } from '@shared/ui/Typography/Text'

interface Props {
  active: boolean
  onClose: () => void
}

export const StaticsModal = ({ active, onClose }: Props) => {
  return (
    <>
      {active && (
        <BlockBoundary>
          <Modal
            title='Статика в подборке'
            handleClose={onClose}
            size='S'
            titleSizes='h1 h3'
            className={s.bottomless}
            mobileShadowless={true}>
            <div className={s.content}>
              <Text sizes='ML M' className={s['text-content']}>
                <span>
                  Демонстрация карточки ресторана в&nbsp;статике на&nbsp;1-м месте в&nbsp;одной из&nbsp;тематических
                  подборок «Выбор Афиши»
                </span>
              </Text>

              <Image src={Img.src} alt='Промо' width={255} height={406} quality={100} />
            </div>
          </Modal>
        </BlockBoundary>
      )}
    </>
  )
}
